import type { FlightConfig, PopulatedFlight } from "./flightPlacementTypes";

/**
 * Builds the initial list of populated flights with empty player arrays.
 *
 * LOGIC:
 * - Starts from the effective flights (either real flights or divisions-as-flights).
 * - Each flight is copied and its players array is reset to [] so that
 *   placement can push registrations into the correct flight without
 *   carrying over previous placement state.
 *
 * This is the structure that placeRegistrationsManual and placeRegistrationsAuto
 * fill in; the result is what gets passed to setPopulatedFlights in the UI.
 */
export function getEmptyPopulatedFlights(effectiveFlights: FlightConfig[]): PopulatedFlight[] {
    return effectiveFlights.map((f: FlightConfig) => ({
        ...f,
        players: Array.isArray(f.players) ? [] : [],
    }));
}
